import { pageViewTypes } from "@constants/tracking";
import FeedbackForm from "@features/feedback/components/FeedbackForm";
import { dialogTexts } from "@features/feedback/constants";
import { defaultFeedbackSubtitle } from "@features/feedback/constants";
import type { FeedbackType } from "@features/feedback/helpers";
import useAnalytics from "@hooks/useAnalytics";
import Box from "@memorang/ui/src/components/Box";
/* -----------------Child components--------------- */
import ModalHeader from "components/ModalHeader";
/* -----------------Globals--------------- */
import { Stack, useLocalSearchParams, useRouter } from "expo-router";
import { useTranslation } from "react-i18next";

const FeedbackRoute = () => {
	useAnalytics({
		type: pageViewTypes.feedback,
	});

	const {
		view,
		itemId,
		sessionId,
		threadId,
		runId,
		type,
		featureName,
		feedbackCta,
		feedbackTitle,
		feedbackSubtitle: feedbackSubtitleParam,
		itemFeedbackRating,
		placeholder,
	} = useLocalSearchParams<{
		view?: string;
		itemId?: string;
		sessionId?: string;
		threadId?: string;
		runId?: string;
		type?: string;
		featureName?: string;
		feedbackCta?: string;
		feedbackTitle?: string;
		feedbackSubtitle?: string;
		feedbackIcon?: string;
		itemFeedbackRating?: string;
		placeholder?: string;
	}>();
	const router = useRouter();
	const config = dialogTexts.feedback;
	const { t } = useTranslation();

	const handleDismissFeedback = () => {
		router.back();
	};
	return (
		<>
			<Stack.Screen
				options={{
					presentation: "modal",
					headerShown: true,
					header: () => (
						<ModalHeader
							backIcon="arrow-left"
							headerTitle={feedbackTitle || t(config.title)}
						/>
					),
				}}
			/>
			<Box padding={16}>
				<FeedbackForm
					view={view || "profile"}
					handleDismiss={handleDismissFeedback}
					feedbackSubtitle={feedbackSubtitleParam || t(defaultFeedbackSubtitle)}
					itemId={itemId}
					sessionId={sessionId ? Number(sessionId) : undefined}
					threadId={threadId}
					runId={runId}
					type={type as FeedbackType}
					featureName={featureName}
					feedbackCta={feedbackCta}
					itemFeedbackRating={itemFeedbackRating as "positive" | "negative"}
					placeholder={placeholder}
				/>
			</Box>
		</>
	);
};

export default FeedbackRoute;
